
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import SettingDescriber from '@/components/shared/SettingDescriber.vue';

@Component<CustomCardStyles>({
	components: {
		SettingDescriber
	}
})
export default class CustomCardStyles extends Vue {
	@Prop({ type: Object, default: () => {} }) private targetMenuConfig!: MenuConfiguration;

	private mutableMenuConfiguration: MenuConfiguration = cloneDeep(this.targetMenuConfig);
	private cardOptions: RadioOptions[] = [
		{ name: this.$t('settings.customize.card_styles.vertical_card_style_rb_label'), value: 'vertical', image: 'vertical-card.svg', option: 1 },
		{ name: this.$t('settings.customize.card_styles.horizontal_card_style_rb_label'), value: 'horizontal', image: 'horizontal-card.svg', option: 2 }
	];
	private cardOptionSelected: number = this.mutableMenuConfiguration.card_style === 'horizontal' ? 2 : 1;

	private changeCardOption(): void {
		const cardStyleValue = this.cardOptions.filter((cardOption: RadioOptions) => cardOption.option === this.cardOptionSelected)[0].value?.toLowerCase();
		Vue.set(this.mutableMenuConfiguration, 'card_style', cardStyleValue);
		this.$emit('update-menu-config', { card_style: cardStyleValue });
	}
}
